/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BodyCreateTaskResourceFile } from './bodyCreateTaskResourceFile';
import type { BodyCreateTaskResourceLinkUrl } from './bodyCreateTaskResourceLinkUrl';
import type { BodyCreateTaskResourceTitle } from './bodyCreateTaskResourceTitle';
import type { BodyCreateTaskResourceDescription } from './bodyCreateTaskResourceDescription';
import type { BodyCreateTaskResourceCitation } from './bodyCreateTaskResourceCitation';

export interface BodyCreateTaskResource {
  file?: BodyCreateTaskResourceFile;
  link_url?: BodyCreateTaskResourceLinkUrl;
  title?: BodyCreateTaskResourceTitle;
  description?: BodyCreateTaskResourceDescription;
  citation?: BodyCreateTaskResourceCitation;
}
